<template>
  <loader v-if="loadingProducts" />
  <div v-else>
    <h5>{{ i18n.t('/pdf/categories/categories corrections label') }}</h5>
    <correction-products-block
      data-qa="corrections-block"
      :products="products"
      :selected-products="selectedProducts"
      :can-add-products="false"
      :products-are-editable="isEditable"
      :products-categories="categories"
      block-type="Corrections"
      class="corrections-block"
      @remove-from-selected="removeFromSelected"
      @add-to-selected="addToSelected"
    >
      <add-correction />
    </correction-products-block>

    <modal
      v-if="showCorrectionsModal"
      title="Correctie toevoegen"
      track-category="service flow"
      @close="showCorrectionsModal = false"
    />
  </div>
</template>

<script>
import CorrectionProductsBlock from '@/components/generic/presentational/organisms/productsBlock/CorrectionProductsBlock.vue'
import HandleAccessoryEvents from '@/mixins/handleAccessoryEvents.js'
import StoreConnector from '@/helpers/StoreConnector'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import AddCorrection from '@/components/generic/presentational/molecules/addCorrection/AddCorrection.vue'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'

export default {
  components: {
    CorrectionProductsBlock,
    Loader,
    Modal,
    AddCorrection,
  },
  mixins: [HandleAccessoryEvents],
  data() {
    return {
      products: [],
      selectedProducts: [],
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      loadingProducts: true,
      showCorrectionsModal: false,
      customCorrectionProduct: null,
      correctionCategoryCode: constants.CORRECTION_CATEGORY_CODE,
      excludedItems: ['PON915'],
      categories: ['Corrections'],
    }
  },
  computed: {
    ...mapGetters({
      quoteStatusIsSalesOrder: 'quote/quoteStatusIsSalesOrder',
    }),

    isEditable() {
      return !this.quoteStatusIsSalesOrder
    },
  },
  created() {
    StoreConnector.get('accessories/loading', (data) => {
      this.loadingProducts = data
    })

    StoreConnector.getWithParam('quote/accessoriesWithCategories', this.categories, (data) => {
      this.selectedProducts = data
    })

    StoreConnector.getWithParam(
      'accessories/accessoriesWithCategories',
      this.categories,
      (data) => {
        this.products = data.filter((p) => !this.excludedItems.includes(p.ID))
      }
    )

    StoreConnector.getWithParam(
      'quote/customCorrectionProduct',
      this.correctionCategoryCode,
      (data) => {
        this.customCorrectionProduct = data
      }
    )
  },
  unmounted() {
    StoreConnector.removeListeners([
      'accessories/loading',
      'accessories/accessoriesWithCategories',
      'quote/accessoriesWithCategories',
      'quote/customCorrectionProduct',
    ])
  },
  methods: {},
}
</script>
